import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=4385af58&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./add.css?vue&type=style&index=0&id=4385af58&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4385af58",
  null
  
)

export default component.exports